import React from "react";
import {
  ActivityCalendar,
  Button,
  Modal,
} from "../../../../../../../components";

const ActivityModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ACTIVITIES"
      width="max-w-7xl"
      closeOnOutsideClick
    >
      <ActivityCalendar />
    </Modal>
  );
};

export default ActivityModal;
